import React from "react";
import {
  Zap,
  Target,
  Microscope,
  BarChart3,
  Handshake,
  ShieldCheck,
} from "lucide-react";
import { WHY } from "../mock/mock";
import useInView from "../hooks/useInView";

const ICONS = { Zap, Target, Microscope, BarChart3, Handshake, ShieldCheck };

export default function WhyUs() {
  const [ref, inView] = useInView();

  return (
    <section id="why" className="relative bg-[#0a1626] py-24">
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 h-[400px] w-[700px] rounded-full bg-[#F5941E]/5 blur-[120px]" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold tracking-[0.2em] text-[#F5941E]">
            {WHY.kicker}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            {WHY.title}
          </h2>
        </div>

        <div ref={ref} className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <div
                key={item.title}
                className={`group rounded-3xl border border-white/10 bg-white/[0.03] p-8 transition-all duration-700 hover:border-[#F5941E]/30 hover:bg-white/[0.05] hover:-translate-y-1 ${
                  inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F5941E]/15 text-[#F5941E] transition-all duration-300 group-hover:bg-[#F5941E] group-hover:text-white group-hover:scale-110">
                  <Icon size={26} />
                </div>
                <h3 className="mt-6 text-lg font-bold text-white">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
